import { DriveItem } from '@microsoft/microsoft-graph-types';

export const isFileFavourite = (file: DriveItem) => {
  const listItemFields = file.listItem?.fields as any;

  if (!listItemFields) {
    return false;
  }

  return listItemFields.Pinned;
};
